import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import { isRevenueAutopilotEnabledForAccount } from '../../../../helper/revenueAutopilotAccess';

import { isOrdersEnabledForAccount } from '../../../../helper/ordersAccess';

const primaryMenuItems = accountId => [
  ...(isOrdersEnabledForAccount(accountId)
    ? [
        {
          icon: 'clipboard',
          key: 'orders',
          label: 'ORDERS',
          toState: frontendURL(`accounts/${accountId}/orders`),
          toStateName: 'orders_dashboard',
        },
      ]
    : []),
  {
    icon: 'mail-inbox',
    key: 'inboxView',
    label: 'INBOX_VIEW',
    featureFlag: FEATURE_FLAGS.INBOX_VIEW,
    toState: frontendURL(`accounts/${accountId}/inbox-view`),
    toStateName: 'inbox_view',
  },
  {
    icon: 'chat',
    key: 'conversations',
    label: 'CONVERSATIONS',
    toState: frontendURL(`accounts/${accountId}/dashboard`),
    toStateName: 'home',
  },
  {
    icon: 'book-contacts',
    key: 'contacts',
    label: 'CONTACTS',
    featureFlag: FEATURE_FLAGS.CRM,
    toState: frontendURL(`accounts/${accountId}/contacts`),
    toStateName: 'contacts_dashboard',
  },
  {
    icon: 'filter',
    key: 'pipelines',
    label: 'PIPELINES',
    toState: frontendURL(`accounts/${accountId}/pipelines`),
    toStateName: 'pipelines_board',
  },
  // Agenda de tareas comerciales (E03): cruza pipelines e incluye tareas sin
  // pipeline, por eso tiene su propio ítem y no es una pestaña de Pipelines.
  {
    icon: 'calendar-clock',
    key: 'tasks',
    label: 'TASKS',
    toState: frontendURL(`accounts/${accountId}/tasks`),
    toStateName: 'tasks_dashboard',
  },
  // Ventas de Chatsell: la entrada existe siempre y el Sidebar la oculta si la
  // cuenta no tiene el módulo activo (se consulta al backend, no es un flag).
  {
    icon: 'credit-card-person',
    key: 'sales',
    label: 'SALES',
    toState: frontendURL(`accounts/${accountId}/sales`),
    toStateName: 'sales_dashboard',
  },
  ...(isRevenueAutopilotEnabledForAccount(accountId)
    ? [
        {
          icon: 'flash-on',
          key: 'revenueAutopilot',
          label: 'REVENUE_AUTOPILOT',
          toState: frontendURL(`accounts/${accountId}/revenue-autopilot`),
          toStateName: 'revenue_autopilot',
        },
      ]
    : []),
  {
    icon: 'arrow-trending-lines',
    key: 'reports',
    label: 'REPORTS',
    featureFlag: FEATURE_FLAGS.REPORTS,
    toState: frontendURL(`accounts/${accountId}/reports`),
    toStateName: 'account_overview_reports',
  },
  // Chatsell: Campañas y Centro de ayuda ocultos del rail (features NO
  // eliminadas; rutas y páginas siguen accesibles por URL).
  /*
  {
    icon: 'megaphone',
    key: 'campaigns',
    label: 'CAMPAIGNS',
    featureFlag: FEATURE_FLAGS.CAMPAIGNS,
    toState: frontendURL(`accounts/${accountId}/campaigns`),
    toStateName: 'ongoing_campaigns',
  },
  {
    icon: 'library',
    key: 'helpcenter',
    label: 'HELP_CENTER.TITLE',
    featureFlag: FEATURE_FLAGS.HELP_CENTER,
    alwaysVisibleOnChatwootInstances: true,
    toState: frontendURL(`accounts/${accountId}/portals`),
    toStateName: 'default_portal_articles',
  },
  */
  {
    icon: 'settings',
    key: 'settings',
    label: 'SETTINGS',
    toState: frontendURL(`accounts/${accountId}/settings`),
    toStateName: 'settings_home',
  },
];

export default primaryMenuItems;
